import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';

function SubmitButton({ onClick, disabled }) {
  return (
    <Box sx={{ marginLeft: 'auto' }}>
      <Button onClick={onClick} disabled={disabled} variant="contained" component="button">
        Создать задачу
      </Button>
    </Box>
  );
}

SubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default SubmitButton;
